export default {
  labels: {
    today: 'Hoje',
    pickup_time: 'Hora de recolha',
    on_site_time: 'Hora de serviço',
    delivery_time: 'Hora de entrega',
  },
};
